export function planUpgradeUrl(platformOrigin: string): string {
  return `${platformOrigin}/?settings=billing&billingView=plans`;
}
